// Browser-only half of the site-host rules; isSameSiteHost and the host lists are in @universal/lib/siteHosts.
import { isSameSiteHost } from '@universal/lib/siteHosts';

/**
 * Points an absolute URL on a host aliased to the current site (e.g. test.naf.no on a planet)
 * at the current origin instead. Other URLs are returned untouched. Browser only.
 */
export const toCurrentSiteUrl = (url: string): string => {
  if (!/^https?:\/\//i.test(url)) return url;
  try {
    const target = new URL(url);
    const { hostname, origin } = window.location;
    if (target.hostname !== hostname && isSameSiteHost(hostname, target.hostname)) {
      return `${origin}${target.pathname}${target.search}${target.hash}`;
    }
  } catch {
    // Fall through with the untouched URL.
  }
  return url;
};
